module.exports = require("./ne-IN.d.ts");